import { Component, ReactNode } from "react";

type Props = { children: ReactNode; name?: string };
type State = { hasError: boolean; err?: any; info?: { componentStack: string } | null; };

const debug = new URLSearchParams(location.search).has("debug");

export class DebugBoundary extends Component<Props, State> {
  state: State = { hasError: false, err: undefined, info: null };

  static getDerivedStateFromError(err: any) {
    return { hasError: true, err };
  }

  componentDidCatch(err: any, info: any) {
    this.setState({ info });
    // also expose globally so you can read it from console on iOS:
    (window as any).__lastError = { err, info };
    try { console.error(`[boundary:${this.props.name ?? "root"}]`, err, info); } catch {}
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    // Friendly fallback in prod; rich details if ?debug=1
    if (!debug) return <div style={{ padding: 16 }}>Oups — une erreur est survenue. Recharge la page.</div>;

    const msg = String(this.state.err?.message ?? this.state.err ?? "Unknown error");
    const stack = String(this.state.err?.stack ?? "");
    const comp = String(this.state.info?.componentStack ?? "");

    return (
      <pre style={{
        whiteSpace: "pre-wrap", font: "14px ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
        padding: 12, background: "#111", color: "#eee", borderRadius: 8, margin: 12, overflow: "auto"
      }}>
        <b>[{this.props.name ?? "root"}]</b> React render error
{"\n"}message: {msg}
{"\n"}stack:
{stack}
{"\n"}componentStack:
{comp}
      </pre>
    );
  }
}
